var React = require('react');

function CircleSmallDarkpurple (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#23C7E5;}\n\t.st2{fill:#947FE8;}\n\t.st3{fill:#6B5ED8;}\n\t.st4{fill:#FD8473;}\n"),React.createElement("g",{"key":1},React.createElement("path",{"className":"st3","d":"M500,0C223.9,0,0,223.9,0,500s223.9,500,500,500c276.1,0,500-223.9,500-500S776.1,0,500,0z M500,919.5\n\t\tC268.3,919.5,80.5,731.7,80.5,500C80.5,268.3,268.3,80.5,500,80.5c231.7,0,419.5,187.8,419.5,419.5\n\t\tC919.5,731.7,731.7,919.5,500,919.5z"}))]);
}

CircleSmallDarkpurple.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 1000 1000","style":{"enableBackground":"new 0 0 1000 1000"},"xmlSpace":"preserve"};

module.exports = CircleSmallDarkpurple;

CircleSmallDarkpurple.default = CircleSmallDarkpurple;
